import Resource from './Resource';

export default class UserConversion extends Resource{
	constructor( options = {} ){
		let {
			baseUrl = "",
			query = {},
			route = "security/user-conversion"
		} = options;

		let config = {
			baseUrl: baseUrl,
			route: route,
			version: "",
			query: query
		};

		super(config);
		return this;
	}

	get(){
		return this.request();
	}
}
